var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupPhase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 125,
    viewBox: "0 0 332 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_96790)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 158,
    height: 124,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 12.5H35C33.3431 12.5 32 13.8431 32 15.5C32 17.1569 33.3431 18.5 35 18.5H61C62.6569 18.5 64 17.1569 64 15.5C64 13.8431 62.6569 12.5 61 12.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 22.5H35C33.3431 22.5 32 23.8431 32 25.5C32 27.1569 33.3431 28.5 35 28.5H79C80.6569 28.5 82 27.1569 82 25.5C82 23.8431 80.6569 22.5 79 22.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 48.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 40.5H35C33.3431 40.5 32 41.8431 32 43.5C32 45.1569 33.3431 46.5 35 46.5H61C62.6569 46.5 64 45.1569 64 43.5C64 41.8431 62.6569 40.5 61 40.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 50.5H35C33.3431 50.5 32 51.8431 32 53.5C32 55.1569 33.3431 56.5 35 56.5H79C80.6569 56.5 82 55.1569 82 53.5C82 51.8431 80.6569 50.5 79 50.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 76.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 68.5H35C33.3431 68.5 32 69.8431 32 71.5C32 73.1569 33.3431 74.5 35 74.5H61C62.6569 74.5 64 73.1569 64 71.5C64 69.8431 62.6569 68.5 61 68.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 78.5H35C33.3431 78.5 32 79.8431 32 81.5C32 83.1569 33.3431 84.5 35 84.5H79C80.6569 84.5 82 83.1569 82 81.5C82 79.8431 80.6569 78.5 79 78.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 104.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 96.5H35C33.3431 96.5 32 97.8431 32 99.5C32 101.157 33.3431 102.5 35 102.5H61C62.6569 102.5 64 101.157 64 99.5C64 97.8431 62.6569 96.5 61 96.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 106.5H35C33.3431 106.5 32 107.843 32 109.5C32 111.157 33.3431 112.5 35 112.5H79C80.6569 112.5 82 111.157 82 109.5C82 107.843 80.6569 106.5 79 106.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.875 61.5L166.875 61.5C166.323 61.5 165.875 61.0523 165.875 60.5V23.5C165.875 22.9477 165.427 22.5 164.875 22.5H157.875",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.875 102.5H164.875C165.427 102.5 165.875 102.052 165.875 101.5V82.281V62.5C165.875 61.9477 166.323 61.5 166.875 61.5H173.875",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 28.5,
    width: 158,
    height: 68,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 48.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 40.5H209C207.343 40.5 206 41.8431 206 43.5C206 45.1569 207.343 46.5 209 46.5H235C236.657 46.5 238 45.1569 238 43.5C238 41.8431 236.657 40.5 235 40.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5 50.5H209.5C207.843 50.5 206.5 51.8431 206.5 53.5C206.5 55.1569 207.843 56.5 209.5 56.5H253.5C255.157 56.5 256.5 55.1569 256.5 53.5C256.5 51.8431 255.157 50.5 253.5 50.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 76.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2396_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 68.5H209C207.343 68.5 206 69.8431 206 71.5C206 73.1569 207.343 74.5 209 74.5H235C236.657 74.5 238 73.1569 238 71.5C238 69.8431 236.657 68.5 235 68.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 78.5H209C207.343 78.5 206 79.8431 206 81.5C206 83.1569 207.343 84.5 209 84.5H253C254.657 84.5 256 83.1569 256 81.5C256 79.8431 254.657 78.5 253 78.5Z",
    fill: "#CBCDC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 124,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 40.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 68.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 96.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 40.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2396_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 68.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPhase);
export default __webpack_public_path__ + "static/media/group-phase.9345529be8625fa0807023a492007f14.svg";
export { ForwardRef as ReactComponent };